module.exports = __webpack_public_path__ + "img/size11.fac0699d.png";